export default "__VITE_ASSET__CFfclhfd__"